import {Card} from '@c/card'
import {Logo} from '@c/logo'
import {doc} from './doc'
import styles from './style.module.styl'

export const CardLayout = doc(
  ({title, children}) => {
    return (
      <div className={styles.cardLayout}>
        <Logo className={styles.logo}  />
        <Card className={styles.card} >
          {children}
        </Card>
      </div>
    )
  }
)
